import { CallFooter } from "./Layout/Footer/CallFooter";
import { CallMainContent } from "./Layout/Main/CallMainContent";

export function CallDisplayUI() {
  return (
    <div
      className="flex h-full flex-col"
      data-testid="call-display"
      data-test="call-active"
    >
      <CallMainContent />
      <CallFooter />
    </div>
  );
}
